<div class="rn-accordion">
  @for (release of sortedReleases(); track release._id) {
    <div class="rn-accordion__item" [class.rn-accordion__item--open]="isExpanded(release._id)">
      <button
        type="button"
        class="rn-accordion__trigger"
        [attr.aria-expanded]="isExpanded(release._id)"
        (click)="toggle(release._id)"
      >
        <div class="rn-accordion__header-text">
          <span class="rn-accordion__date">{{ formatDate(release.releaseDate) }}</span>
          <span class="rn-accordion__meta">
            <span>Version {{ release.versionNumber }}</span>
            <span class="rn-accordion__sep">·</span>
            <span>Build {{ release.buildNumber }}</span>
          </span>
        </div>
        <app-admin-icon
          name="chevron-down"
          [size]="18"
          class="rn-accordion__chevron"
          [class.rn-accordion__chevron--open]="isExpanded(release._id)"
        />
      </button>

      <div class="rn-accordion__panel" [class.rn-accordion__panel--open]="isExpanded(release._id)">
        <div class="rn-accordion__panel-inner">
          <p class="rn-accordion__summary">
            Here's what's new in <strong>Version {{ release.versionNumber }}</strong>
            (Build <strong>{{ release.buildNumber }}</strong>)
          </p>
          <p class="rn-accordion__lede">{{ release.shortSummary }}</p>

          @for (section of categorySections; track section.category) {
            @if (hasCategoryItems(release, section.category)) {
              <section class="rn-accordion__section">
                <h3 class="rn-accordion__section-title">
                  {{ section.emoji }} {{ section.label }}
                </h3>
                <div class="rn-accordion__cards">
                  @for (item of itemsForCategory(release, section.category); track item.id) {
                    <article class="rn-update-view-card">
                      <span class="rn-update-view-card__badge">{{ categoryLabels[item.category] }}</span>
                      <h4 class="rn-update-view-card__title">{{ item.title }}</h4>
                      <div class="rn-update-view-card__body" [innerHTML]="item.description"></div>
                      <app-release-image-gallery [imageUrls]="item.imageUrls" />
                    </article>
                  }
                </div>
              </section>
            }
          }
        </div>
      </div>
    </div>
  }
</div>
